import React from 'react';

const VARIANTS = {
  primary: 'bg-gradient-to-r from-primary via-primary-dark to-indigo-600 text-white shadow-lg shadow-primary/25 hover:shadow-xl hover:-translate-y-0.5',
  success: 'bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-lg shadow-emerald-500/25 hover:shadow-xl hover:-translate-y-0.5',
  danger: 'bg-gradient-to-r from-red-500 to-pink-500 text-white shadow-lg shadow-red-500/25 hover:shadow-xl hover:-translate-y-0.5',
  // Recognizable action colors reused across record tables (view/edit/export)
  info: 'bg-gradient-to-r from-blue-500 to-cyan-500 text-white shadow-md hover:shadow-lg',
  purple: 'bg-gradient-to-r from-purple-500 to-indigo-500 text-white shadow-md hover:shadow-lg',
  secondary: 'bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600',
  outline: 'bg-white border-2 border-slate-200 text-slate-700 hover:border-primary/40 hover:text-primary dark:bg-slate-800 dark:border-slate-600 dark:text-slate-200 dark:hover:border-accent/50 dark:hover:text-accent',
  ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700/60'
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs gap-1.5 rounded-lg',
  md: 'px-4 py-2.5 text-sm gap-2 rounded-xl',
  lg: 'px-6 py-3 text-sm sm:text-base gap-2 rounded-xl'
};

// Central button used across the app so every action (create/save/delete/
// cancel/etc.) shares one visual language instead of each page hand-rolling
// its own gradient + shadow combination.
const Button = React.forwardRef(({
  variant = 'primary',
  size = 'md',
  icon,
  loading = false,
  fullWidth = false,
  className = '',
  children,
  type = 'button',
  disabled,
  ...rest
}, ref) => {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center font-semibold transition-all duration-200 whitespace-nowrap active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 dark:focus-visible:ring-accent/50 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-none disabled:active:scale-100 ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...rest}
    >
      {loading ? (
        <i className="fas fa-spinner fa-spin" aria-hidden="true"></i>
      ) : icon ? (
        <i className={`fas ${icon}`} aria-hidden="true"></i>
      ) : null}
      {children}
    </button>
  );
});

export default Button;
